import React from "react";
import totalMarks from "../../../assests/result/TotalMarks.png";
import correct from "../../../assests/result/Correct.png";
import incorrect from "../../../assests/result/InCorrect.png";
import unanswered from "../../../assests/result/Unanswered.png";
import rank from "../../../assests/result/Rank.png";
import time from "../../../assests/result/TimeImg.png";

const Overview = ({ overviewReportData }) => {
  const formatValue = (value) => {
    return Number(value) % 1 === 0 ? value : Number(value).toFixed(2);
  };
  const calculateMark =
    ((overviewReportData?.polity?.correct +
      overviewReportData?.polity?.incorrect +
      overviewReportData?.polity?.unanswered) *
      11) /
    5;
  const overviewData = [
    {
      image: totalMarks,
      label: "Total Marks Scored",
      value: `${
        overviewReportData?.polity?.totalPoints
          ? formatValue(overviewReportData.polity.totalPoints)
          : "0"
      }/${calculateMark}`,
    },
    {
      image: correct,
      label: "Correct",
      value: overviewReportData?.polity?.correct,
    },
    {
      image: incorrect,
      label: "Incorrect",
      value: overviewReportData?.polity?.incorrect,
    },
    {
      image: unanswered,
      label: "Unanswered",
      value: overviewReportData?.polity?.unanswered,
    },
    { image: rank, label: "Rank", value: overviewReportData?.polity?.rank },
    { image: time, label: "Time", value: overviewReportData?.polity?.time },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {overviewData?.map((item, index) => (
        <div
          key={index}
          className="flex items-center gap-6 bg-white border border-[#DBE0E6] rounded-lg py-4 px-4 xl:px-7 "
        >
          <div className="h-14">
            <img src={item?.image} alt="" className="h-full" />
          </div>
          <div>
            <p className="text-lg font-semibold text-gray-500">{item?.label}</p>
            <h2 className="text-xl font-bold text-gray-800">{item?.value}</h2>
            {item?.label === "Time" && (
              <h2 className="text-sm font-bold text-gray-800">HH:MM</h2>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Overview;
